export function formatDateFR(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleString('fr-FR', {
    timeZone: 'Europe/Paris',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    // hour: '2-digit',
    // minute: '2-digit',
  })
}